import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { EMPTY_CELL_VALUE, TOTALS_ROW_ID } from '../consts/grid.consts.jsx';

const identifyCellValueState = <T extends CustomCellRendererProps>(
  params: T,
) => {
  if (!params.data || !params.colDef?.colId) {
    return { isInvalid: true };
  }

  const isTotalRow = params.data.id === TOTALS_ROW_ID;
  const isReadOnly = params.data.attributes[params.colDef.colId]?.isReadOnly;
  const isEmptyField = params.value === EMPTY_CELL_VALUE && isReadOnly;
  const isEmptyFieldEditable =
    (params.value === EMPTY_CELL_VALUE || params.value === undefined) &&
    !isReadOnly;

  return {
    isTotalRow,
    isReadOnly,
    isEmptyField,
    isEmptyFieldEditable,
    isInvalid: false,
  };
};

export const getFormattedValue = (
  params: CustomCellRendererProps,
  {
    formatterFn,
    placeholderText,
  }: {
    formatterFn: () => string | undefined | null;
    placeholderText: string;
  },
) => {
  const {
    isTotalRow,
    isReadOnly,
    isEmptyField,
    isEmptyFieldEditable,
    isInvalid,
  } = identifyCellValueState(params);

  if (isEmptyField || isInvalid) {
    return EMPTY_CELL_VALUE;
  }

  if (isEmptyFieldEditable) {
    return <span className="text-text-placeholder">{placeholderText}</span>;
  }

  const formattedValue = formatterFn();

  if (params.value && isReadOnly && !isTotalRow) {
    return <span className="text-text-placeholder">{formattedValue}</span>;
  }

  return <span>{formattedValue}</span>;
};
